import {COVERGO_ASIA_DR} from "../consts.js"

export const infra_dr = {
	"infra-studio.dr.asia.covergo.cloud": {
		appConfig: {
			tenantId: "infra",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_DR,
		fileSystem: {
			bucketName: "covergo-apse1-dr-infra"
		}
	},
}

